export const resizeUnfilledSlider = ({
  ref,
}: {
  ref: React.RefObject<HTMLInputElement>;
}) => {
  if (ref.current) {
    const node = ref.current;
    const percent = ((+node.value - +node.min) / (+node.max - +node.min)) * 100;
    node.style.setProperty('--progress', `${100 - percent}%`);
  }
};
